<template>
  <div :class="['rate', selected ? 'selected' : '']" :style="cssVars">
    <label class="rate-label">
      <input @input="updateSelectedRate"
             v-if="selectable"
             type="radio"
             v-model="selected_rate_id"
             :name="`shipments[${shipmentUuid}][selected_rate_id]`"
             :value="id"
             :id="id"
      />
      <div class="logo hidden-xs">
        <img :src="providerLogo" alt="logo"/>
      </div>
      <div class="rate-description">
        <h4>{{ provider }} - {{ name }}</h4>
        <span class="rate-terms">{{ durationTerms }}</span>
      </div>
      <div class="rate-price">
        <div>{{ total | formattedPrice(currency) }} <span class="currency">{{ currency }}</span></div>
        <div class="compare">{{ total * 1.5 | formattedPrice(currency) }} {{ currency }}</div>
      </div>
    </label>
  </div>
</template>

<style scoped>
.logo {
  width: 25px;
  align-self: flex-start;
}

.logo img {
  width: 100%;
  object-fit: contain;
}

h4 {
  margin: 0;
}

.rates .rate:first-child {
  border-top: 1px solid #C8C8C8;
}

.rate {
  background-color: #fff;
  //background-color: #f2f2f2;
  border-bottom: 1px solid #C8C8C8;
  transition: all 0.3s;
}

.rate:hover, .rate.selected{
  background-color: #F2F2F2 !important;
}

.rate:last-child {
  border-bottom: none;
}

input[type=radio], input[type=checkbox] {
  margin-right: 24px;
}

.rate .logo {
  margin-right: 24px;
}

.selectable label {
  cursor: pointer;
}

.rate-label {
  display: flex;
  padding: 20px;
  align-items: center;
}

.rate-description {
  margin-right: 32px;
  flex: 1;
}

.rate-terms {
  display: block;
  font-weight: 400;
  font-size: 13.5px;
  line-height: 150%;
}

.rate-price {
  margin-left: auto;
  white-space: nowrap;
  font-weight: 700;
}

.compare {
  text-decoration: line-through;
  font-weight: 400;
  font-size: 13.5px;
  line-height: 150%;
  text-align: right;
  color: #5A5A5A;
}

.currency {
  font-weight: 700;
  font-size: 13.5px;
  line-height: 150%;
  color: #929292;
}
</style>

<script>


import {useShipmentStore} from "../stores/shipment";
import {storeToRefs} from "pinia";
import {useOrderStore} from "../stores/order";

export default {
  setup(props) {
    const order = useOrderStore()
    const shipment = useShipmentStore(props.shipmentUuid)
    const {patchShipment} = shipment;

    const {
      selected_rate_id,
    } = storeToRefs(shipment)

    const {
      uuid,
    } = storeToRefs(order)

    return{
      selected_rate_id,
      patchShipment,
      orderUuid: uuid,
    }
  },
  components: {},
  props: {
    selectable: {
      type: Boolean,
      default: true,
    },
    id: String,
    shipmentUuid: String,
    name: String,
    provider: String,
    providerLogo: String,
    durationTerms: String,
    currency: String,
    total: Number,
    backgroundColor: {
      type: String,
      default: '#fbfbfb',
    },
  },
  data: () => ({}),
  methods: {
    updateSelectedRate() {
      this.patchShipment({selected_rate_id: this.id}, this.orderUuid)
    },
  },
  computed: {
    cssVars() {
      return {
        '--bg-color': this.backgroundColor,
        '--bg-hover-color': this.selectable ? '#F2F2F2' : this.backgroundColor,
      }
    },
    selected: function () {
      return this.selected_rate_id === this.id
    },
  }
}
</script>
